/* Chuckanut Bay Distillery redesign: small page behaviors (no dependencies) */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* current nav item */
  var path = location.pathname.replace(/\/$/, '') || '/';
  $$('.nav a, .mn-panel a').forEach(function (a) {
    var h = (a.getAttribute('href') || '').split('#')[0].replace(/\/$/, '');
    if (h && h !== '/' && (path === h || path.indexOf(h + '/') === 0)) { a.classList.add('is-current'); a.setAttribute('aria-current', 'page'); }
  });

  /* home hero carousel */
  var slides = $$('.hslide');
  if (slides.length > 1) {
    var dots = $$('.hdot'), cur = 0, paused = false;
    var show = function (i) {
      cur = i;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); d.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    var hero = $('.h2hero');
    if (hero) {
      hero.addEventListener('mouseenter', function () { paused = true; });
      hero.addEventListener('mouseleave', function () { paused = false; });
      hero.addEventListener('focusin', function () { paused = true; });
      hero.addEventListener('focusout', function () { paused = false; });
    }
    if (!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      setInterval(function () { if (!paused && !document.hidden) show((cur + 1) % slides.length); }, 7000);
    }
  }

  /* FAQ accordion */
  var qas = $$('.qa');
  if (qas.length) {
    var setQa = function (qa, open) {
      var b = $('.qbtn', qa), a = $('.ans', qa), s = $('.qsign', qa);
      if (!b || !a) return;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      a.hidden = !open; if (s) s.textContent = open ? '−' : '+';
    };
    qas.forEach(function (qa, i) {
      setQa(qa, i === 0);
      var b = $('.qbtn', qa);
      if (b) b.addEventListener('click', function () { setQa(qa, b.getAttribute('aria-expanded') !== 'true'); });
    });
    $$('button.tlink').forEach(function (btn) {
      if (!/expand all/i.test(btn.textContent)) return;
      btn.addEventListener('click', function () {
        var open = /expand/i.test(btn.textContent);
        qas.forEach(function (qa) { setQa(qa, open); });
        btn.textContent = open ? 'Collapse all' : 'Expand all';
      });
    });
  }

  /* chip filters: recipes (.rc), reviews, calendar events, galleries tabs */
  $$('.chips').forEach(function (group) {
    var chips = $$('button.chip', group);
    if (!chips.length || group.closest('[data-cbd-shop]')) return;
    var scope = group.closest('section') || document;
    var items = $$('.rc, .rvc, .ev', scope).filter(function (el) { return !el.closest('.chips'); });
    if (!items.length) return;
    var count = $('[aria-live="polite"]', scope);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.toggle('on', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        var label = chip.textContent.trim().toLowerCase();
        var all = /^all/.test(label);
        var n = 0;
        items.forEach(function (el) {
          var txt = el.textContent.toLowerCase();
          var ok = all || txt.indexOf(label.replace(/s$/, '')) >= 0 || (label === 'ticketed' && /ticket/.test(txt));
          el.hidden = !ok; if (ok) n++;
        });
        if (count && /\d/.test(count.textContent)) count.textContent = count.textContent.replace(/\d+/, n);
      });
    });
  });

  /* shop filters */
  var shop = $('[data-cbd-shop]');
  if (shop) {
    var state = { type: 'all', line: 'all' };
    var cards = $$('[data-type]', shop);
    var label = $('[data-count]', shop);
    var apply = function () {
      var n = 0;
      cards.forEach(function (c) {
        var ok = (state.type === 'all' || c.dataset.type === state.type) && (state.line === 'all' || c.dataset.line === state.line);
        c.hidden = !ok; if (ok) n++;
      });
      if (label) label.textContent = n + (n === 1 ? ' product' : ' products');
      var feat = $$('[data-feat]');
      feat.forEach(function (f) { f.hidden = !(state.type === 'all' && state.line === 'all'); });
    };
    $$('[data-filter]', shop).forEach(function (chip) {
      var key = chip.dataset.filter, val = chip.dataset.value;
      var has = val === 'all' || cards.some(function (c) { return c.dataset[key] === val; });
      if (!has) { chip.hidden = true; return; }
      chip.addEventListener('click', function () {
        state[key] = val;
        $$('[data-filter="' + key + '"]', shop).forEach(function (c) { var on = c === chip; c.classList.toggle('on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
      });
    });
  }

  /* product gallery + variants + quantity */
  var stage = $('.stage img');
  $$('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      var img = $('img', b); if (!img || !stage) return;
      stage.src = img.dataset.full || img.src; stage.alt = img.alt || stage.alt;
      $$('.thumbs button').forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    });
  });
  var pform = $('form[data-cbd-product]');
  if (pform) {
    var vid = $('input[name="id"]', pform), qty = $('input[name="quantity"]', pform);
    var priceEls = $$('[data-cbd-price]'), btn = $('[data-cbd-add]', pform);
    var variants = JSON.parse(($('#cbd-variants') || {}).textContent || '[]');
    var fmt = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };
    var refresh = function () {
      var v = variants.find(function (x) { return String(x.id) === vid.value; }) || variants[0];
      if (!v) return;
      var q = Math.max(1, parseInt(qty.value, 10) || 1);
      priceEls.forEach(function (e) { e.textContent = fmt(v.price); });
      if (btn) {
        btn.disabled = !v.available;
        $('[data-cbd-total]', btn).textContent = v.available ? fmt(v.price * q) : 'Sold out';
      }
    };
    $$('[data-cbd-variant]').forEach(function (b) {
      b.addEventListener('click', function () {
        vid.value = b.dataset.cbdVariant;
        $$('[data-cbd-variant]').forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        refresh();
      });
    });
    $$('[data-cbd-step]', pform).forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.cbdStep, 10)); refresh(); });
    });
    qty.addEventListener('change', refresh);
    refresh();
  }

  /* recipe scaler */
  var seg = $('.seg');
  var ing = $$('.ing li b');
  if (seg && ing.length) {
    var FR = { '¼': .25, '½': .5, '¾': .75, '⅓': 1 / 3, '⅔': 2 / 3, '⅛': .125 };
    var parse = function (s) {
      var m = s.match(/^(\d+)?\s*([¼½¾⅓⅔⅛])?(.*)$/);
      if (!m || (!m[1] && !m[2])) return null;
      return { n: (m[1] ? +m[1] : 0) + (m[2] ? FR[m[2]] : 0), rest: m[3] };
    };
    var show = function (n) {
      var w = Math.floor(n), f = n - w, best = '', d = 1;
      Object.keys(FR).forEach(function (k) { if (Math.abs(FR[k] - f) < d) { d = Math.abs(FR[k] - f); best = k; } });
      if (f < .06) return String(w); if (f > .94) return String(w + 1);
      return (w ? w : '') + best;
    };
    ing.forEach(function (b) { b.dataset.base = b.textContent; });
    $$('button', seg).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var k = parseInt(btn.textContent, 10) || 1;
        $$('button', seg).forEach(function (x) { var on = x === btn; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        ing.forEach(function (b) { var p = parse(b.dataset.base); b.textContent = p ? show(p.n * k) + p.rest : b.dataset.base; });
        var note = seg.closest('div').parentNode.querySelector('.ing + p');
        if (note) note.textContent = k === 1 ? 'Makes one drink.' : 'Makes ' + k + ' drinks.';
      });
    });
  }

  /* reveal buttons (pricing guide forms) */
  $$('[data-reveal]').forEach(function (b) {
    b.addEventListener('click', function () { var t = document.getElementById(b.dataset.reveal); if (t) { t.hidden = false; b.hidden = true; } });
  });

  /* photo lightbox */
  var openLb = function (src, alt) {
    var lb = document.createElement('div');
    lb.className = 'cbd-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Photo');
    lb.innerHTML = '<button type="button" aria-label="Close">×</button><img alt="">';
    lb.querySelector('img').src = src; lb.querySelector('img').alt = alt || '';
    var close = function () { lb.remove(); document.removeEventListener('keydown', esc); };
    var esc = function (e) { if (e.key === 'Escape') close(); };
    lb.addEventListener('click', close); document.addEventListener('keydown', esc);
    document.body.appendChild(lb); lb.querySelector('button').focus();
  };
  $$('.shot').forEach(function (b) { b.addEventListener('click', function () { var i = $('img', b); if (i) openLb(i.src, i.alt); }); });
  $$('.cbd-masonry img').forEach(function (i) { i.addEventListener('click', function () { openLb(i.currentSrc || i.src, i.alt); }); });

  /* calendar: today's hours from the weekly table */
  var hours = document.getElementById('hours');
  if (hours) {
    var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    var d = (new Date().getDay() + 6) % 7;
    var rows = $$('.wk tbody tr', hours);
    rows.forEach(function (r, k) { r.classList.toggle('today', k === d); });
    var eb = $('.eyebrow', hours); if (eb) eb.textContent = 'Today is ' + DAYS[d];
    var row = rows[d];
    if (row) {
      var cells = $$('td', row).slice(1);
      $$('.nowc', hours).forEach(function (c, k) {
        var cell = cells[k]; if (!cell) return;
        var p = $$('p', c)[1]; if (!p) return;
        var closed = /closed/i.test(cell.textContent);
        p.innerHTML = '<span class="dot ' + (closed ? 'closed' : 'open') + '"></span>' + cell.textContent;
      });
    }
  }
})();
